/* eslint-disable max-statements */
/* eslint-disable complexity */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-lines-per-function */
// Libraries
import { FormElems, Alert } from '../';
import { getPermissionsOptions, getIntent } from '../../utils/helperMethods';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { isEmpty } from 'lodash';

// Components

// Helper Methods

// Styles
import './roleMakerView.scss';

const RoleMakerView = props => {
    const { data, roleManagementData } = props;

    const { updateRole } = roleManagementData;

    const [accessManagementOptions, setAccessManagementOptions] = useState([]);
    const [mobOptions, setMobOptions] = useState([]);
    const [reportOptions, setReportOptions] = useState([]);
    const [refundOptions, setRefundOptions] = useState([]);
    const [manageBinOptions, setManageBinOptions] = useState([]);
    const [manageAccountOptions, setManageAccountOptions] = useState([]);
    const [myAccountOptions, setMyAccountOptions] = useState([]);
    const [dashboardOptions, setDashboardOptions] = useState([]);
    const [payLinkOption, setPayLinkOption] = useState([]);
    const [auditTrailOption, setAuditTrailOption] = useState([]);
    const [mandateOption, setMandateOption] = useState([]);
    const [mobEditOption , setMobEditOption] = useState([]);

    useEffect(() => {
        if (data && data.resourceDetail) {
            const resourcePermissionDetails = [...data.resourceDetail];
            const resourcePermissionDetailsOld = [...data.resourceDetailOld];

            // Format Access Management Data
            const accessManagementOptions = getPermissionsOptions(
                resourcePermissionDetailsOld,
                resourcePermissionDetails,
                'access_management'
            );

            setAccessManagementOptions(accessManagementOptions);

            // Format Reports Data
            const reportOptions = getPermissionsOptions(
                resourcePermissionDetailsOld,
                resourcePermissionDetails,
                'reports'
            );

            setReportOptions(reportOptions);

            // Format Refund Data
            const refundOptions = getPermissionsOptions(
                resourcePermissionDetailsOld,
                resourcePermissionDetails,
                'refunds'
            );

            setRefundOptions(refundOptions);

            // Format Manage Bin Data
            const manageBinOptions = getPermissionsOptions(
                resourcePermissionDetailsOld,
                resourcePermissionDetails,
                'manage_bin'
            );
            setManageBinOptions(manageBinOptions);

            // Format Manage Account Data
            const manageAccountOptions = getPermissionsOptions(
                resourcePermissionDetailsOld,
                resourcePermissionDetails,
                'manage_account'
            );
            setManageAccountOptions(manageAccountOptions);

            // Format My Account Data
            const myAccountOptions = getPermissionsOptions(
                resourcePermissionDetailsOld,
                resourcePermissionDetails,
                'my_account'
            );
            setMyAccountOptions(myAccountOptions);

            // Format Dashboard Data
            const dashboardOptions = getPermissionsOptions(
                resourcePermissionDetailsOld,
                resourcePermissionDetails,
                'dashboard'
            );
            setDashboardOptions(dashboardOptions);

            // Form Merchant Onboard Data
            const mobOptions = getPermissionsOptions(
                resourcePermissionDetailsOld,
                resourcePermissionDetails,
                'merchant_onboarding'
            );

            setMobOptions(mobOptions);

            // Format Payment Link Data
            const payLinkOptions = getPermissionsOptions(
                resourcePermissionDetailsOld,
                resourcePermissionDetails,
                'payment_links'
            );
            setPayLinkOption(payLinkOptions);

            // Format Payment Link Data
            const auditTrailOption = getPermissionsOptions(
                resourcePermissionDetailsOld,
                resourcePermissionDetails,
                'audit_trail'
            );
            setAuditTrailOption(auditTrailOption);

            const mandateOption = getPermissionsOptions(
                resourcePermissionDetailsOld,
                resourcePermissionDetails,
                'mandates'
            );
            setMandateOption(mandateOption);

            const mobEditOption = getPermissionsOptions(
                resourcePermissionDetailsOld,
                resourcePermissionDetails,
                'edit_merchant_onboarding'
            );
            setMobEditOption(mobEditOption);
        }
    }, [data]);


    return (
        <form className="role-view-edit role-view-maker">
            <div className="form-section">
                <div className="form-field status-section">
                    <p className="label">Status</p>
                    <>
                        <div className={`status ${data.roleStatus}`}>
                            <span className="text-simple">
                                {data.roleStatus}
                            </span>
                            {data.roleStatusOld &&
                            data.roleStatus !== data.roleStatusOld ? (
                                <span className="strike-through">
                                    {data.roleStatusOld}
                                </span>
                            ) : null}
                        </div>
                        <div className="lastupdate-status">
                            {data.roleCreatedUpdatedName && (
                                <>
                                    {getIntent(data.lastActions)}{' '}
                                    <strong>
                                        {data.roleCreatedUpdatedName},{' '}
                                    </strong>
                                    {moment(data.roleCreatedDate, 'DD/MM/YYYY')
                                        .calendar()
                                        .indexOf('Today') >= 0
                                        ? 'Today'
                                        : moment(
                                              data.roleCreatedDate,
                                              'DD/MM/YYYY'
                                          )
                                              .calendar()
                                              .indexOf('Yesterday') >= 0
                                        ? 'Yesterday'
                                        : data.roleCreatedDate}
                                </>
                            )}
                        </div>
                    </>
                </div>
            </div>
            <div className="management-section">
                <div className="left-section">
                    {!isEmpty(accessManagementOptions) ? (
                        <div className="form-section">
                            <p className="label">Access Management</p>
                            <div className="form-field disabled">
                                <Field
                                    name="access_management"
                                    options={accessManagementOptions || []}
                                    valueField="value"
                                    isDisabled={true}
                                    labelField="label"
                                    component={FormElems.Checkbox}
                                />
                            </div>
                        </div>
                    ) : null}
                    {!isEmpty(reportOptions) ? (
                        <div className="form-section">
                            <p className="label">Reports</p>
                            <div className="form-field disabled">
                                <Field
                                    name="reports"
                                    options={reportOptions || []}
                                    valueField="value"
                                    isDisabled={true}
                                    labelField="label"
                                    component={FormElems.Checkbox}
                                />
                            </div>
                        </div>
                    ) : null}
                    {!isEmpty(refundOptions) ? (
                        <div className="form-section">
                            <p className="label">Refunds</p>
                            <div className="form-field disabled">
                                <Field
                                    name="refunds"
                                    options={refundOptions || []}
                                    valueField="value"
                                    isDisabled={true}
                                    labelField="label"
                                    component={FormElems.Checkbox}
                                />
                            </div>
                        </div>
                    ) : null}
                    {!isEmpty(dashboardOptions) ? (
                        <div className="form-section">
                            <p className="label">Dashboard</p>
                            <div className="form-field disabled">
                                <Field
                                    name="dashboard"
                                    options={dashboardOptions || []}
                                    valueField="value"
                                    isDisabled={true}
                                    labelField="label"
                                    component={FormElems.Checkbox}
                                />
                            </div>
                        </div>
                    ) : null}
                    {!isEmpty(auditTrailOption) ? (
                        <div className="form-section">
                            <p className="label">Audit Report</p>
                            <div className="form-field disabled">
                                <Field
                                    name="audit_trail"
                                    options={auditTrailOption || []}
                                    valueField="value"
                                    isDisabled={true}
                                    labelField="label"
                                    component={FormElems.Checkbox}
                                />
                            </div>
                        </div>
                    ) : null}
                </div>
                <div className="right-section">
                    {!isEmpty(mobOptions) ? (
                        <div className="form-section">
                            <p className="label">Merchant Onboarding</p>
                            <div className="form-field disabled">
                                <FormElems.Checkbox
                                    name="merchant_onboarding"
                                    options={mobOptions || []}
                                    valueField="value"
                                    labelField="label"
                                    isDisabled={true}
                                />
                            </div>
                        </div>
                    ) : null}
                    {!isEmpty(manageBinOptions) ? (
                        <div className="form-section">
                            <p className="label">Manage Bin</p>
                            <div className="form-field disabled">
                                <Field
                                    name="manage_bin"
                                    options={manageBinOptions || []}
                                    valueField="value"
                                    isDisabled={true}
                                    labelField="label"
                                    component={FormElems.Checkbox}
                                />
                            </div>
                        </div>
                    ) : null}
                    {!isEmpty(manageAccountOptions) ? (
                        <div className="form-section">
                            <p className="label">Manage Account</p>
                            <div className="form-field disabled">
                                <Field
                                    name="manage_account"
                                    options={manageAccountOptions || []}
                                    valueField="value"
                                    isDisabled={true}
                                    labelField="label"
                                    component={FormElems.Checkbox}
                                />
                            </div>
                        </div>
                    ) : null}
                    {!isEmpty(myAccountOptions) ? (
                        <div className="form-section">
                            <p className="label">My Account</p>
                            <div className="form-field disabled">
                                <Field
                                    name="my_account"
                                    options={myAccountOptions || []}
                                    valueField="value"
                                    isDisabled={true}
                                    labelField="label"
                                    component={FormElems.Checkbox}
                                />
                            </div>
                        </div>
                    ) : null}
                    {!isEmpty(payLinkOption) ? (
                        <div className="form-section">
                            <p className="label">Payment Links</p>
                            <div className="form-field disabled">
                                <Field
                                    name="payLink"
                                    options={payLinkOption || []}
                                    valueField="value"
                                    isDisabled={true}
                                    labelField="label"
                                    component={FormElems.Checkbox}
                                />
                            </div>
                        </div>
                    ) : null}
                    {!isEmpty(mandateOption) ? (
                        <div className="form-section">
                            <p className="label">Mandate</p>
                            <div className="form-field disabled">
                                <Field
                                    name="mandates"
                                    options={mandateOption || []}
                                    valueField="value"
                                    isDisabled={true}
                                    labelField="label"
                                    component={FormElems.Checkbox}
                                />
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
            <div className="form-section comment-box">
                <div className="label">Comment</div>
                <div className="comment-text" style={{ display: 'block' }}>
                    {data.checkerComment
                        ? data.checkerComment
                        : data.makerComment || '-'}
                </div>
            </div>
            {updateRole.message ? <Alert>{updateRole.message}</Alert> : null}
        </form>
    );
};

const mapStateToProps = ({ auth, roleManagementData, form }) => ({
    auth,
    roleManagementData,
    formData: form['role-checker-view'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({}, dispatch),
});

RoleMakerView.propTypes = {
    data: PropTypes.object,
    roleManagementData: PropTypes.object,
};

export default compose(
    reduxForm({
        form: 'role-checker-view',
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(RoleMakerView);
